import type { DateTime } from '@backmarket/http-api/src/standards'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import type { RequestStatusType } from '~/api/seller-after-sales/types'

export function useFormatDeadline(
  deadline: DateTime | null,
  orderId: string,
  status?: RequestStatusType,
) {
  const HOUR_IN_MILLISECONDS = 1000 * 60 * 60
  const logger = useLogger()

  if (status === 'UPCOMING') {
    return 'upcoming'
  }

  if (deadline === null) {
    logger.error(
      `Request deadline is null with status TODO for order #${orderId}`,
      { owners: ['bot-squad-seller-care-front'] },
    )

    return 'todo'
  }

  if (new Date(deadline) < new Date()) {
    const hoursLate =
      (Date.now() - new Date(deadline).getTime()) / HOUR_IN_MILLISECONDS

    if (hoursLate > 24) {
      const daysLate = Math.ceil(hoursLate / 24)

      return `${daysLate} days late`
    }

    return `${Math.ceil(hoursLate)} hours late`
  }

  const hoursLeft =
    (new Date(deadline).getTime() - Date.now()) / HOUR_IN_MILLISECONDS

  if (hoursLeft > 24) {
    const daysLeft = Math.ceil(hoursLeft / 24)

    return `${daysLeft} days left`
  }

  return `${Math.ceil(hoursLeft)} hours left`
}
